module.exports = __webpack_public_path__ + "img/pin.5ceb202f.svg";